/**
 * R36S i18n — translates hardcoded FR strings on non-FR pages
 * Periodic sweep (no MutationObserver). Covers MoonBundle delayed render.
 * Languages: de, es, en, pt, nl, it, ja, ko, pl, ro, sv, tr
 */
(function() {
  'use strict';

  var lang = (document.documentElement.lang || 'fr').split('-')[0].toLowerCase();
  if (lang === 'fr' || !lang) return;

  // Common strings translated for ALL languages
  var T = {
    de: {
      // Cart
      "Votre panier": "Dein Warenkorb",
      "Vous économisez": "Du sparst",
      "Total estimé": "Geschätzte Gesamtkosten",
      "Total": "Gesamt", "Sous-total": "Zwischensumme",
      "Quantité": "Menge", "Quantité :": "Menge:",
      "COMMANDER": "BESTELLEN", "Commander": "Bestellen",
      "Continuer mes achats": "Weiter einkaufen",
      "Frais de port calculés": "Versandkosten werden berechnet",
      "Inclus la TVA": "inkl. MwSt.",
      // Trust bar
      "LIVRAISON GRATUITE": "GRATIS VERSAND",
      "REMBOURSÉ 30 JOURS": "30 TAGE RÜCKGABE",
      "PAIEMENT SÉCURISÉ": "SICHERES BEZAHLEN",
      "Livraison Gratuite": "Gratis Versand",
      "Remboursé 30 jours": "30 Tage Rückgabe",
      "Paiement Sécurisé": "Sicheres Bezahlen",
      "Paiement express": "Express-Zahlung",
      "Paiement sécurisé avec": "Sichere Zahlung mit",
      // Gifts
      "🎁 Cadeau offert": "🎁 Geschenk inklusive",
      "Cadeau offert": "Geschenk inklusive",
      "🎁 CADEAU OFFERT": "🎁 GESCHENK",
      "CADEAU OFFERT": "GESCHENK",
      "Produit Gratuit": "Gratis Produkt",
      "Cadeaux": "Geschenke",
      "Cadeau": "Geschenk",
      "GRATUIT": "GRATIS", "Gratuit": "Gratis",
      // Variants
      "Couleur:": "Farbe:", "Couleur ": "Farbe ", "Couleur": "Farbe",
      "Stockage:": "Speicher:", "Stockage ": "Speicher ", "Stockage": "Speicher",
      "Taille:": "Größe:", "Taille ": "Größe ",
      "Modèle:": "Modell:", "Modèle ": "Modell ",
      "Matériau:": "Material:", "Capacité:": "Kapazität:",
      "Violet": "Violett", "Noir": "Schwarz", "Blanc": "Weiß",
      "Rouge": "Rot", "Bleu": "Blau", "Vert": "Grün",
      "Jaune": "Gelb", "Rose": "Rosa", "Gris": "Grau", "Marron": "Braun",
      // MoonBundle / urgency
      "PROFITEZ-EN VITE !": "JETZT ZUSCHLAGEN!",
      "PROFITEZ-EN VITE": "JETZT ZUSCHLAGEN",
      "Offre se terminant dans": "Angebot endet in",
      "Le meilleur du retro-gaming au meilleur prix. Stock limité.": "Das Beste vom Retro-Gaming zum besten Preis. Begrenzte Stückzahl.",
      "Le meilleur du retro-gaming au meilleur prix": "Das Beste vom Retro-Gaming zum besten Preis",
      "Stock limité": "Begrenzte Stückzahl",
      "Offre Basique": "Basis-Angebot",
      "Meilleure Offre": "Bestes Angebot",
      "Économisez": "Spare", "économisez": "sparst",
      "Forte demande : il ne reste que quelques pièces.": "Hohe Nachfrage: nur noch wenige Stück verfügbar.",
      "Forte demande": "Hohe Nachfrage",
      "il ne reste que quelques pièces": "nur noch wenige Stück verfügbar",
      "AJOUTER AU PANIER": "IN DEN WARENKORB",
      "Ajouter au panier": "In den Warenkorb",
      "Voir tous les détails": "Vollständige Details anzeigen",
      "Voir les détails": "Details ansehen",
      // Menu
      "Accueil": "Startseite",
      "Contact": "Kontakt",
      "Recherche": "Suche",
      "Connexion": "Anmelden",
      "Mon compte": "Mein Konto",
      // Product page
      "Description": "Beschreibung",
      "Avis": "Bewertungen",
      "Avis clients": "Kundenbewertungen",
      "Caractéristiques": "Eigenschaften",
      "Spécifications": "Spezifikationen",
      "Acheter maintenant": "Jetzt kaufen",
      "JE COMMANDE": "JETZT BESTELLEN", "Je commande": "Jetzt bestellen",
      "En stock": "Auf Lager",
      "Rupture de stock": "Nicht verfügbar",
      "Épuisé": "Ausverkauft",
      "Disponible": "Verfügbar",
      "Quantité disponible": "Verfügbare Menge",
      "Garantie": "Garantie",
      "Livraison": "Versand",
      "En savoir plus": "Mehr erfahren",
      "Plus d'informations": "Weitere Informationen",
      // Footer / generic
      "Politique de confidentialité": "Datenschutzerklärung",
      "Conditions générales": "AGB",
      "Mentions légales": "Impressum",
      "Service client": "Kundenservice",
      // Reviews / social proof
      "Noté 4.8 par 5000+ Clients!": "4.8 Sterne von 5000+ Kunden!",
      "Noté 4.8 par 5000+ Clients": "4.8 Sterne von 5000+ Kunden",
      "5000+ Clients": "5000+ Kunden",
      "Clients!": "Kunden!",
      "4.8 Excellent": "4.8 Ausgezeichnet",
      "Excellent": "Ausgezeichnet",
      // Announcement bar
      "rapide et gratuite": "schnell und kostenlos",
      "Livraison rapide et gratuite": "Schneller & kostenloser Versand",
      "retro-gaming": "Retro-Gaming",
      // Product names + extras
      "R36S - Console de jeu rétro portable": "R36S - Tragbare Retro-Spielekonsole",
      "Console de jeu rétro portable": "Tragbare Retro-Spielekonsole",
      "Protection R36S": "R36S Schutzhülle",
      "Poignée R36s Console": "R36S Konsolen-Griffhalterung",
      "Poignée": "Griffhalterung",
      "Coque de R36S": "R36S Gehäuse",
      "Coque de": "Gehäuse für",
      "4x Vitres de Protection R36S": "4x R36S Displayschutzfolien",
      "Vitres de Protection R36S": "R36S Displayschutzfolien",
      "Vitres de Protection": "Displayschutzfolien",
      "ADD TO CART": "IN DEN WARENKORB",
      "Starter Pack - R36S": "Starter-Paket - R36S",
      "Starter Pack": "Starter-Paket",
      "Pack Gamer": "Gamer-Paket",
      "Pack Ultimate": "Ultimate-Paket",
      "Aucun avis pour le moment": "Noch keine Bewertungen",
      "Soyez le premier à laisser un avis": "Schreibe die erste Bewertung",
      // Title + catch-all
      "console rétro portable": "tragbare Retro-Konsole",
      "meilleure console": "beste Konsole",
      "Acheter la meilleure": "Kaufe die beste",
      "Game Master R36S - Acheter la meilleure console retro portable": "Game Master R36S - Beste tragbare Retro-Konsole kaufen",
      // EN remnants
      "Rated 4.8/5 — 2,400+ consoles shipped in 2026!": "Bewertung 4.8/5 — 2.400+ Konsolen versendet in 2026!",
      "2,400+ consoles shipped in 2026!": "2.400+ Konsolen versendet in 2026!",
      "Rated 4.8/5": "Bewertung 4.8/5",
    },
    it: {
      "Votre panier": "Il tuo carrello",
      "Vous économisez": "Risparmi",
      "Total estimé": "Totale stimato",
      "Total": "Totale", "Sous-total": "Subtotale",
      "Quantité": "Quantità", "Quantité :": "Quantità:",
      "COMMANDER": "ORDINA", "Commander": "Ordina",
      "Continuer mes achats": "Continua gli acquisti",
      "LIVRAISON GRATUITE": "SPEDIZIONE GRATUITA",
      "REMBOURSÉ 30 JOURS": "RIMBORSO 30 GIORNI",
      "PAIEMENT SÉCURISÉ": "PAGAMENTO SICURO",
      "Livraison Gratuite": "Spedizione Gratuita",
      "Remboursé 30 jours": "Rimborso 30 Giorni",
      "Paiement Sécurisé": "Pagamento Sicuro",
      "Paiement express": "Pagamento espresso",
      "🎁 Cadeau offert": "🎁 Regalo incluso",
      "Cadeau offert": "Regalo incluso",
      "🎁 CADEAU OFFERT": "🎁 REGALO", "CADEAU OFFERT": "REGALO",
      "Produit Gratuit": "Prodotto Gratuito",
      "Cadeaux": "Regali", "Cadeau": "Regalo",
      "GRATUIT": "GRATIS", "Gratuit": "Gratis",
      "Couleur:": "Colore:", "Couleur": "Colore",
      "Stockage:": "Memoria:", "Stockage": "Memoria",
      "Taille:": "Taglia:", "Modèle:": "Modello:",
      "Violet": "Viola", "Noir": "Nero", "Blanc": "Bianco",
      "Rouge": "Rosso", "Bleu": "Blu", "Vert": "Verde",
      "Jaune": "Giallo", "Rose": "Rosa", "Gris": "Grigio",
      "PROFITEZ-EN VITE !": "APPROFITTANE SUBITO!",
      "Offre se terminant dans": "Offerta termina tra",
      "Le meilleur du retro-gaming au meilleur prix. Stock limité.": "Il meglio del retro-gaming al miglior prezzo. Disponibilità limitata.",
      "Stock limité": "Disponibilità limitata",
      "Offre Basique": "Offerta Base",
      "Meilleure Offre": "Migliore Offerta",
      "Économisez": "Risparmia",
      "Forte demande : il ne reste que quelques pièces.": "Alta domanda: rimangono solo pochi pezzi.",
      "Forte demande": "Alta domanda",
      "il ne reste que quelques pièces": "rimangono solo pochi pezzi",
      "AJOUTER AU PANIER": "AGGIUNGI AL CARRELLO",
      "Ajouter au panier": "Aggiungi al carrello",
      "Voir tous les détails": "Vedi tutti i dettagli",
      "Voir les détails": "Vedi dettagli",
      "Accueil": "Home", "Contact": "Contatto", "Recherche": "Cerca",
      "Description": "Descrizione",
      "Avis": "Recensioni", "Avis clients": "Recensioni clienti",
      "Acheter maintenant": "Compra ora",
      "JE COMMANDE": "ORDINA ORA", "Je commande": "Ordina ora",
      "En stock": "Disponibile", "Rupture de stock": "Esaurito",
      "Épuisé": "Esaurito",
      "Garantie": "Garanzia", "Livraison": "Spedizione",
      // Reviews
      "Noté 4.8 par 5000+ Clients!": "Valutato 4.8 da 5000+ Clienti!",
      "Noté 4.8 par 5000+ Clients": "Valutato 4.8 da 5000+ Clienti",
      "5000+ Clients": "5000+ Clienti",
      "Clients!": "Clienti!",
      "Noté": "Valutato",
      "4.8 Excellent": "4.8 Eccellente",
      "Excellent": "Eccellente",
      // Announcement bar
      "rapide et gratuite": "veloce e gratuita",
      "Livraison rapide et gratuite": "Spedizione veloce e gratuita",
      "retro-gaming": "retro gaming",
      "Spedizione rapide et gratuite": "Spedizione veloce e gratuita",
      // Product names + extras
      "R36S - Console de jeu rétro portable": "R36S - Console di gioco retrò portatile",
      "Console de jeu rétro portable": "Console di gioco retrò portatile",
      "Protection R36S": "Protezione R36S",
      "Poignée R36s Console": "Impugnatura per R36s",
      "Coque de R36S": "Custodia R36S",
      "4x Vitres de Protection R36S": "4x Pellicole Protettive R36S",
      "Vitres de Protection R36S": "Pellicole Protettive R36S",
      "ADD TO CART": "AGGIUNGI AL CARRELLO",
      "Starter Pack - R36S": "Pack Iniziale - R36S",
      "Starter Pack": "Pack Iniziale",
      "Pack Gamer": "Pack Gamer",
      "Pack Ultimate": "Pack Ultimate",
      "Vous avez": "Hai",
      "Aucun avis pour le moment": "Nessuna recensione al momento",
      "Soyez le premier à laisser un avis": "Sii il primo a lasciare una recensione",
      // Title + catch-all
      "console retro portable": "console retrò portatile",
      "console rétro portable": "console retrò portatile",
      "console rétro": "console retrò",
      "console retro": "console retrò",
      "meilleure console": "migliore console",
      "Acheter la meilleure": "Compra la migliore",
      "Game Master R36S - Acheter la meilleure console retro portable": "Game Master R36S - Compra la migliore console retrò portatile",
      "Apri contenuti multimediali": "Apri contenuti multimediali",
      "livraison rapide": "spedizione veloce",
      "Livraison rapide": "Spedizione veloce",
      // EN remnants
      "Rated 4.8/5 — 2,400+ consoles shipped in 2026!": "Valutato 4.8/5 — 2.400+ console spedite nel 2026!",
      "2,400+ consoles shipped in 2026!": "2.400+ console spedite nel 2026!",
      "2,400+ consoles shipped in 2026": "2.400+ console spedite nel 2026",
      "Rated 4.8/5": "Valutato 4.8/5",
      // Catch-all
      "Le meilleur du retro-gaming au meilleur prix": "Il meglio del retro gaming al miglior prezzo",
    },
    es: {
      "Votre panier": "Tu carrito", "Vous économisez": "Ahorras",
      "Total estimé": "Total estimado", "Total": "Total", "Sous-total": "Subtotal",
      "Quantité": "Cantidad",
      "COMMANDER": "PEDIR", "Commander": "Pedir",
      "LIVRAISON GRATUITE": "ENVÍO GRATIS",
      "REMBOURSÉ 30 JOURS": "REEMBOLSO 30 DÍAS",
      "PAIEMENT SÉCURISÉ": "PAGO SEGURO",
      "Paiement express": "Pago rápido",
      "🎁 Cadeau offert": "🎁 Regalo incluido",
      "Cadeau offert": "Regalo incluido",
      "Produit Gratuit": "Producto Gratis",
      "Cadeaux": "Regalos", "Cadeau": "Regalo",
      "GRATUIT": "GRATIS", "Gratuit": "Gratis",
      "Couleur:": "Color:", "Couleur": "Color",
      "Stockage:": "Almacenamiento:", "Stockage": "Almacenamiento",
      "Violet": "Violeta", "Noir": "Negro", "Blanc": "Blanco",
      "Rouge": "Rojo", "Bleu": "Azul", "Vert": "Verde",
      "PROFITEZ-EN VITE !": "¡APROVECHA YA!",
      "Stock limité": "Stock limitado",
      "Offre Basique": "Oferta Básica",
      "Meilleure Offre": "Mejor Oferta",
      "Économisez": "Ahorra",
      "Forte demande": "Alta demanda",
      "AJOUTER AU PANIER": "AÑADIR AL CARRITO",
      "Voir tous les détails": "Ver todos los detalles",
      "Accueil": "Inicio", "Contact": "Contacto",
      "Description": "Descripción", "Avis": "Reseñas",
      "Acheter maintenant": "Comprar ahora",
      "En stock": "En stock", "Rupture de stock": "Agotado",
      // Reviews
      "Noté 4.8 par 5000+ Clients!": "¡Calificado 4.8 por 5000+ Clientes!",
      "Noté 4.8 par 5000+ Clients": "Calificado 4.8 por 5000+ Clientes",
      "5000+ Clients": "5000+ Clientes",
      "Clients!": "Clientes!",
      "Noté": "Calificado",
      "4.8 Excellent": "4.8 Excelente",
      "Excellent": "Excelente",
      // Announcement bar
      "rapide et gratuite": "rápido y gratis",
      "Livraison rapide et gratuite": "Envío rápido y gratis",
      "retro-gaming": "retro-gaming",
      // Product names + extras
      "R36S - Console de jeu rétro portable": "R36S - Consola de juegos retro portátil",
      "Console de jeu rétro portable": "Consola de juegos retro portátil",
      "Protection R36S": "Protección R36S",
      "Poignée R36s Console": "Empuñadura R36s Consola",
      "Coque de R36S": "Funda R36S",
      "4x Vitres de Protection R36S": "4x Protectores de Pantalla R36S",
      "Vitres de Protection R36S": "Protectores de Pantalla R36S",
      "ADD TO CART": "AÑADIR AL CARRITO",
      "Starter Pack": "Pack Inicial",
      "Pack Gamer": "Pack Gamer",
      "Pack Ultimate": "Pack Ultimate",
      // Title + catch-all
      "console rétro portable": "consola retro portátil",
      "meilleure console": "mejor consola",
      "Acheter la meilleure": "Compra la mejor",
      // EN remnants
      "Rated 4.8/5 — 2,400+ consoles shipped in 2026!": "Calificado 4.8/5 — ¡2.400+ consolas enviadas en 2026!",
      "2,400+ consoles shipped in 2026!": "¡2.400+ consolas enviadas en 2026!",
      "Rated 4.8/5": "Calificado 4.8/5",
      // Catch-all
      "Le meilleur du retro-gaming au meilleur prix. Stock limité.": "Lo mejor del retro-gaming al mejor precio. Stock limitado.",
      "Le meilleur du retro-gaming au meilleur prix": "Lo mejor del retro-gaming al mejor precio",
    },
    en: {
      "Votre panier": "Your cart", "Vous économisez": "You save",
      "Total estimé": "Estimated total", "Total": "Total", "Sous-total": "Subtotal",
      "Quantité": "Quantity",
      "COMMANDER": "CHECKOUT", "Commander": "Checkout",
      "LIVRAISON GRATUITE": "FREE SHIPPING",
      "REMBOURSÉ 30 JOURS": "30-DAY REFUND",
      "PAIEMENT SÉCURISÉ": "SECURE PAYMENT",
      "Paiement express": "Express checkout",
      "🎁 Cadeau offert": "🎁 Free Gift", "Cadeau offert": "Free Gift",
      "Produit Gratuit": "Free Product",
      "Cadeaux": "Gifts", "Cadeau": "Gift",
      "GRATUIT": "FREE", "Gratuit": "Free",
      "Couleur:": "Color:", "Couleur": "Color",
      "Stockage:": "Storage:", "Stockage": "Storage",
      "Violet": "Purple", "Noir": "Black", "Blanc": "White",
      "Rouge": "Red", "Bleu": "Blue", "Vert": "Green",
      "PROFITEZ-EN VITE !": "GRAB IT FAST!",
      "Stock limité": "Limited stock",
      "Offre Basique": "Basic Offer",
      "Meilleure Offre": "Best Offer",
      "Économisez": "Save", "Forte demande": "High demand",
      "AJOUTER AU PANIER": "ADD TO CART",
      "Voir tous les détails": "View full details",
      "Accueil": "Home", "Contact": "Contact",
      "Description": "Description", "Avis": "Reviews",
      "Acheter maintenant": "Buy now",
      "En stock": "In stock", "Rupture de stock": "Out of stock",
      // Reviews
      "Noté 4.8 par 5000+ Clients!": "Rated 4.8 by 5000+ Customers!",
      "Noté 4.8 par 5000+ Clients": "Rated 4.8 by 5000+ Customers",
      "5000+ Clients": "5000+ Customers",
      "Clients!": "Customers!",
      "Noté": "Rated",
      // Announcement bar
      "rapide et gratuite": "fast and free",
      "Livraison rapide et gratuite": "Fast & free shipping",
      // Product names + extras
      "R36S - Console de jeu rétro portable": "R36S - Portable Retro Game Console",
      "Console de jeu rétro portable": "Portable Retro Game Console",
      "Protection R36S": "R36S Case",
      "Poignée R36s Console": "R36s Console Grip",
      "Coque de R36S": "R36S Cover",
      "4x Vitres de Protection R36S": "4x R36S Screen Protectors",
      "Vitres de Protection R36S": "R36S Screen Protectors",
      "Starter Pack": "Starter Pack",
      "Pack Gamer": "Gamer Pack",
      "Pack Ultimate": "Ultimate Pack",
      // Title + catch-all
      "console rétro portable": "portable retro console",
      "meilleure console": "best console",
      "Acheter la meilleure": "Buy the best",
      // Catch-all
      "Le meilleur du retro-gaming au meilleur prix. Stock limité.": "The best of retro-gaming at the best price. Limited stock.",
      "Le meilleur du retro-gaming au meilleur prix": "The best of retro-gaming at the best price",
    },
    pt: {
      "Votre panier": "Seu carrinho", "Vous économisez": "Você economiza",
      "Total estimé": "Total estimado", "Quantité": "Quantidade",
      "COMMANDER": "FINALIZAR", "Commander": "Finalizar",
      "LIVRAISON GRATUITE": "FRETE GRÁTIS",
      "REMBOURSÉ 30 JOURS": "REEMBOLSO 30 DIAS",
      "PAIEMENT SÉCURISÉ": "PAGAMENTO SEGURO",
      "Paiement express": "Pagamento rápido",
      "🎁 Cadeau offert": "🎁 Brinde", "Cadeau offert": "Brinde",
      "Produit Gratuit": "Produto Grátis",
      "Cadeaux": "Brindes", "Cadeau": "Brinde",
      "GRATUIT": "GRÁTIS", "Gratuit": "Grátis",
      "Couleur:": "Cor:", "Couleur": "Cor",
      "Stockage:": "Armazenamento:",
      "Violet": "Roxo", "Noir": "Preto", "Blanc": "Branco",
      "Rouge": "Vermelho", "Bleu": "Azul", "Vert": "Verde",
      "PROFITEZ-EN VITE !": "APROVEITE!",
      "Stock limité": "Estoque limitado",
      "Économisez": "Economize", "Forte demande": "Alta procura",
      "AJOUTER AU PANIER": "ADICIONAR AO CARRINHO",
      "Voir tous les détails": "Ver todos os detalhes",
      "Accueil": "Início", "Contact": "Contato",
      "Description": "Descrição", "Avis": "Avaliações",
      // Reviews
      "Noté 4.8 par 5000+ Clients!": "Avaliado 4.8 por 5000+ Clientes!",
      "Noté 4.8 par 5000+ Clients": "Avaliado 4.8 por 5000+ Clientes",
      "5000+ Clients": "5000+ Clientes",
      "Clients!": "Clientes!",
      "Noté": "Avaliado",
      "Excellent": "Excelente",
      // Announcement bar
      "rapide et gratuite": "rápido e grátis",
      "Livraison rapide et gratuite": "Frete rápido e grátis",
      // Product names + extras
      "R36S - Console de jeu rétro portable": "R36S - Console de Jogos Retrô Portátil",
      "Console de jeu rétro portable": "Console de Jogos Retrô Portátil",
      "Protection R36S": "Proteção R36S",
      "Poignée R36s Console": "Empunhadura R36s",
      "Coque de R36S": "Capa R36S",
      "4x Vitres de Protection R36S": "4x Películas Protetoras R36S",
      "Vitres de Protection R36S": "Películas Protetoras R36S",
      "ADD TO CART": "ADICIONAR AO CARRINHO",
      "Starter Pack": "Pack Inicial",
      // Title + catch-all
      "console rétro portable": "console retro portátil",
      "meilleure console": "melhor console",
      // EN remnants
      "Rated 4.8/5 — 2,400+ consoles shipped in 2026!": "Avaliado 4.8/5 — 2.400+ consoles enviados em 2026!",
      "Rated 4.8/5": "Avaliado 4.8/5",
      // Catch-all
      "Le meilleur du retro-gaming au meilleur prix. Stock limité.": "O melhor do retro-gaming pelo melhor preço. Estoque limitado.",
      "Le meilleur du retro-gaming au meilleur prix": "O melhor do retro-gaming pelo melhor preço",
    },
    nl: {
      "Votre panier": "Je winkelwagen", "Vous économisez": "Je bespaart",
      "Total estimé": "Geschat totaal", "Quantité": "Aantal",
      "COMMANDER": "BESTELLEN", "Commander": "Bestellen",
      "LIVRAISON GRATUITE": "GRATIS VERZENDING",
      "REMBOURSÉ 30 JOURS": "30 DAGEN RETOUR",
      "PAIEMENT SÉCURISÉ": "VEILIG BETALEN",
      "Paiement express": "Snelle betaling",
      "🎁 Cadeau offert": "🎁 Gratis Cadeau", "Cadeau offert": "Gratis Cadeau",
      "Produit Gratuit": "Gratis Product",
      "Cadeaux": "Cadeaus", "Cadeau": "Cadeau",
      "GRATUIT": "GRATIS", "Gratuit": "Gratis",
      "Couleur:": "Kleur:", "Couleur": "Kleur",
      "Stockage:": "Opslag:",
      "Violet": "Paars", "Noir": "Zwart", "Blanc": "Wit",
      "Rouge": "Rood", "Bleu": "Blauw", "Vert": "Groen",
      "PROFITEZ-EN VITE !": "GRIJP DE KANS!",
      "Stock limité": "Beperkte voorraad",
      "Offre Basique": "Basis Aanbieding",
      "Meilleure Offre": "Beste Aanbieding",
      "Économisez": "Bespaar", "Forte demande": "Hoge vraag",
      "AJOUTER AU PANIER": "TOEVOEGEN AAN WINKELWAGEN",
      "Voir tous les détails": "Volledige details bekijken",
      "Accueil": "Home", "Contact": "Contact",
      "Description": "Beschrijving", "Avis": "Beoordelingen",
      // Reviews
      "Noté 4.8 par 5000+ Clients!": "Beoordeeld 4.8 door 5000+ Klanten!",
      "Noté 4.8 par 5000+ Clients": "Beoordeeld 4.8 door 5000+ Klanten",
      "5000+ Clients": "5000+ Klanten",
      "Clients!": "Klanten!",
      "Noté": "Beoordeeld",
      "Excellent": "Uitstekend",
      // Announcement bar
      "rapide et gratuite": "snel en gratis",
      "Livraison rapide et gratuite": "Snelle & gratis verzending",
      // Product names + extras
      "R36S - Console de jeu rétro portable": "R36S - Draagbare Retro Game Console",
      "Console de jeu rétro portable": "Draagbare Retro Game Console",
      "Protection R36S": "R36S Beschermhoes",
      "Poignée R36s Console": "R36s Console Greep",
      "Coque de R36S": "R36S Hoes",
      "4x Vitres de Protection R36S": "4x R36S Schermbeschermers",
      "Vitres de Protection R36S": "R36S Schermbeschermers",
      "ADD TO CART": "TOEVOEGEN AAN WINKELWAGEN",
      "Starter Pack": "Starter Pack",
      // Title + catch-all
      "console rétro portable": "draagbare retro console",
      "meilleure console": "beste console",
      // EN remnants
      "Rated 4.8/5 — 2,400+ consoles shipped in 2026!": "Beoordeeld 4.8/5 — 2.400+ consoles verzonden in 2026!",
      "Rated 4.8/5": "Beoordeeld 4.8/5",
      // Catch-all
      "Le meilleur du retro-gaming au meilleur prix. Stock limité.": "Het beste van retro-gaming voor de beste prijs. Beperkte voorraad.",
      "Le meilleur du retro-gaming au meilleur prix": "Het beste van retro-gaming voor de beste prijs",
    },
    ja: {
      "Votre panier": "カート", "Vous économisez": "節約",
      "COMMANDER": "注文する",
      "LIVRAISON GRATUITE": "送料無料",
      "REMBOURSÉ 30 JOURS": "30日間返金",
      "PAIEMENT SÉCURISÉ": "安全な決済",
      "Paiement express": "エクスプレス決済",
      "🎁 Cadeau offert": "🎁 ギフト", "Cadeau offert": "ギフト",
      "Produit Gratuit": "無料商品",
      "Cadeaux": "ギフト", "Cadeau": "ギフト",
      "GRATUIT": "無料", "Gratuit": "無料",
      "Couleur:": "色:", "Couleur": "色",
      "Stockage:": "ストレージ:",
      "Violet": "パープル", "Noir": "ブラック", "Blanc": "ホワイト",
      "PROFITEZ-EN VITE !": "今すぐお見逃しなく!",
      "Stock limité": "在庫限り",
      "Économisez": "節約", "Forte demande": "需要が高い",
      "AJOUTER AU PANIER": "カートに追加",
      "Accueil": "ホーム", "Contact": "お問い合わせ",
      // Reviews
      "Noté 4.8 par 5000+ Clients!": "5000+人のお客様から4.8評価!",
      "Noté 4.8 par 5000+ Clients": "5000+人のお客様から4.8評価",
      "5000+ Clients": "5000+人のお客様",
      "Clients!": "お客様!",
      "Excellent": "優秀",
      // Announcement bar
      "rapide et gratuite": "迅速で無料",
      "Livraison rapide et gratuite": "送料無料・迅速配送",
      // Product names + extras
      "R36S - Console de jeu rétro portable": "R36S - 携帯レトロゲーム機",
      "Console de jeu rétro portable": "携帯レトロゲーム機",
      "Protection R36S": "R36S 保護ケース",
      "Coque de R36S": "R36S カバー",
      "ADD TO CART": "カートに追加",
      // EN remnants
      "Rated 4.8/5 — 2,400+ consoles shipped in 2026!": "評価4.8/5 — 2026年に2,400+台出荷!",
      "Rated 4.8/5": "評価4.8/5",
      // Catch-all
      "Le meilleur du retro-gaming au meilleur prix": "最高の価格でレトロゲーミングの最高の体験",
      // Asian/Eastern fixes
      "Offre Basique": "ベーシックオファー",
      "Meilleure Offre": "ベストオファー",
      "Poignée": "グリップ",
      "rétro": "レトロ",
    },
    ko: {
      "Votre panier": "장바구니", "Vous économisez": "절약",
      "COMMANDER": "주문하기",
      "LIVRAISON GRATUITE": "무료 배송",
      "REMBOURSÉ 30 JOURS": "30일 환불",
      "PAIEMENT SÉCURISÉ": "안전한 결제",
      "Paiement express": "빠른 결제",
      "🎁 Cadeau offert": "🎁 무료 선물", "Cadeau offert": "무료 선물",
      "Produit Gratuit": "무료 상품",
      "Cadeaux": "선물", "Cadeau": "선물",
      "GRATUIT": "무료", "Gratuit": "무료",
      "Couleur:": "색상:", "Couleur": "색상",
      "Violet": "보라색", "Noir": "검정", "Blanc": "흰색",
      "PROFITEZ-EN VITE !": "지금 잡아!",
      "Stock limité": "재고 한정",
      "AJOUTER AU PANIER": "장바구니에 추가",
      "Accueil": "홈", "Contact": "연락처",
      // Reviews
      "Noté 4.8 par 5000+ Clients!": "5000+ 고객으로부터 4.8 평점!",
      "Noté 4.8 par 5000+ Clients": "5000+ 고객으로부터 4.8 평점",
      "5000+ Clients": "5000+ 고객",
      "Clients!": "고객!",
      "Excellent": "우수",
      // Announcement bar
      "rapide et gratuite": "빠르고 무료",
      "Livraison rapide et gratuite": "빠르고 무료 배송",
      // Product names + extras
      "R36S - Console de jeu rétro portable": "R36S - 휴대용 레트로 게임기",
      "Console de jeu rétro portable": "휴대용 레트로 게임기",
      "Protection R36S": "R36S 보호 케이스",
      "ADD TO CART": "장바구니에 추가",
      // EN remnants
      "Rated 4.8/5 — 2,400+ consoles shipped in 2026!": "평점 4.8/5 — 2026년 2,400+대 발송!",
      // Catch-all
      "Le meilleur du retro-gaming au meilleur prix": "최고의 가격으로 최고의 레트로 게임",
      // Asian/Eastern fixes
      "Offre Basique": "기본 제안",
      "Meilleure Offre": "최고 제안",
      "Poignée": "그립",
      "rétro": "레트로",
    },
    pl: {
      "Votre panier": "Twój koszyk", "Vous économisez": "Oszczędzasz",
      "COMMANDER": "ZAMÓW",
      "LIVRAISON GRATUITE": "DARMOWA DOSTAWA",
      "REMBOURSÉ 30 JOURS": "ZWROT 30 DNI",
      "PAIEMENT SÉCURISÉ": "BEZPIECZNA PŁATNOŚĆ",
      "Paiement express": "Płatność ekspresowa",
      "🎁 Cadeau offert": "🎁 Prezent", "Cadeau offert": "Prezent",
      "Produit Gratuit": "Produkt Gratis", "Cadeaux": "Prezenty", "Cadeau": "Prezent",
      "GRATUIT": "GRATIS", "Gratuit": "Gratis",
      "Couleur:": "Kolor:", "Couleur": "Kolor",
      "Violet": "Fioletowy", "Noir": "Czarny", "Blanc": "Biały",
      "PROFITEZ-EN VITE !": "ŚPIESZ SIĘ!",
      "Stock limité": "Ograniczona ilość",
      "AJOUTER AU PANIER": "DODAJ DO KOSZYKA",
      "Accueil": "Strona główna", "Contact": "Kontakt",
      // Reviews
      "Noté 4.8 par 5000+ Clients!": "Ocena 4.8 od 5000+ Klientów!",
      "Noté 4.8 par 5000+ Clients": "Ocena 4.8 od 5000+ Klientów",
      "5000+ Clients": "5000+ Klientów",
      "Clients!": "Klientów!",
      "Noté": "Ocena",
      "Excellent": "Doskonały",
      // Announcement bar
      "rapide et gratuite": "szybka i darmowa",
      "Livraison rapide et gratuite": "Szybka i darmowa dostawa",
      // Product names + extras
      "R36S - Console de jeu rétro portable": "R36S - Przenośna Konsola Retro",
      "Console de jeu rétro portable": "Przenośna Konsola Retro",
      "Protection R36S": "Etui R36S",
      "ADD TO CART": "DODAJ DO KOSZYKA",
      // EN remnants
      "Rated 4.8/5 — 2,400+ consoles shipped in 2026!": "Ocena 4.8/5 — 2.400+ konsol wysłanych w 2026!",
      // Catch-all
      "Le meilleur du retro-gaming au meilleur prix": "Najlepsze retro gaming w najlepszej cenie",
      // Asian/Eastern fixes
      "Offre Basique": "Oferta Podstawowa",
      "Meilleure Offre": "Najlepsza Oferta",
      "Poignée": "Uchwyt",
      "rétro": "retro",
    },
    ro: {
      "Votre panier": "Coșul tău", "Vous économisez": "Economisești",
      "COMMANDER": "COMANDĂ",
      "LIVRAISON GRATUITE": "LIVRARE GRATUITĂ",
      "REMBOURSÉ 30 JOURS": "RAMBURS 30 ZILE",
      "PAIEMENT SÉCURISÉ": "PLATĂ SIGURĂ",
      "Paiement express": "Plată rapidă",
      "🎁 Cadeau offert": "🎁 Cadou", "Cadeau offert": "Cadou",
      "Produit Gratuit": "Produs Gratis", "Cadeaux": "Cadouri", "Cadeau": "Cadou",
      "GRATUIT": "GRATIS", "Gratuit": "Gratis",
      "Couleur:": "Culoare:", "Couleur": "Culoare",
      "Violet": "Violet", "Noir": "Negru", "Blanc": "Alb",
      "PROFITEZ-EN VITE !": "PROFITĂ ACUM!",
      "Stock limité": "Stoc limitat",
      "AJOUTER AU PANIER": "ADAUGĂ ÎN COȘ",
      "Accueil": "Acasă", "Contact": "Contact",
      // Reviews
      "Noté 4.8 par 5000+ Clients!": "Evaluat 4.8 de 5000+ Clienți!",
      "Noté 4.8 par 5000+ Clients": "Evaluat 4.8 de 5000+ Clienți",
      "5000+ Clients": "5000+ Clienți",
      "Clients!": "Clienți!",
      "Noté": "Evaluat",
      "Excellent": "Excelent",
      // Announcement bar
      "rapide et gratuite": "rapidă și gratuită",
      "Livraison rapide et gratuite": "Livrare rapidă și gratuită",
      // Product names + extras
      "R36S - Console de jeu rétro portable": "R36S - Consolă Retro Portabilă",
      "Console de jeu rétro portable": "Consolă Retro Portabilă",
      "Protection R36S": "Carcasă R36S",
      "ADD TO CART": "ADAUGĂ ÎN COȘ",
      // EN remnants
      "Rated 4.8/5 — 2,400+ consoles shipped in 2026!": "Evaluat 4.8/5 — 2.400+ console expediate în 2026!",
      // Catch-all
      "Le meilleur du retro-gaming au meilleur prix": "Cel mai bun retro-gaming la cel mai bun preț",
      // Asian/Eastern fixes
      "Offre Basique": "Ofertă Bază",
      "Meilleure Offre": "Cea Mai Bună Ofertă",
      "Poignée": "Mâner",
      "rétro": "retro",
    },
    sv: {
      "Votre panier": "Din varukorg", "Vous économisez": "Du sparar",
      "COMMANDER": "BESTÄLL",
      "LIVRAISON GRATUITE": "GRATIS FRAKT",
      "REMBOURSÉ 30 JOURS": "30 DAGARS RETUR",
      "PAIEMENT SÉCURISÉ": "SÄKER BETALNING",
      "Paiement express": "Snabb betalning",
      "🎁 Cadeau offert": "🎁 Gratis Gåva", "Cadeau offert": "Gratis Gåva",
      "Produit Gratuit": "Gratis Produkt", "Cadeaux": "Gåvor", "Cadeau": "Gåva",
      "GRATUIT": "GRATIS", "Gratuit": "Gratis",
      "Couleur:": "Färg:", "Couleur": "Färg",
      "Violet": "Lila", "Noir": "Svart", "Blanc": "Vit",
      "PROFITEZ-EN VITE !": "PASSA PÅ!",
      "Stock limité": "Begränsat lager",
      "AJOUTER AU PANIER": "LÄGG I VARUKORG",
      "Accueil": "Hem", "Contact": "Kontakt",
      // Reviews
      "Noté 4.8 par 5000+ Clients!": "Betygsatt 4.8 av 5000+ Kunder!",
      "Noté 4.8 par 5000+ Clients": "Betygsatt 4.8 av 5000+ Kunder",
      "5000+ Clients": "5000+ Kunder",
      "Clients!": "Kunder!",
      "Noté": "Betygsatt",
      "Excellent": "Utmärkt",
      // Announcement bar
      "rapide et gratuite": "snabb och gratis",
      "Livraison rapide et gratuite": "Snabb och gratis frakt",
      // Product names + extras
      "R36S - Console de jeu rétro portable": "R36S - Bärbar Retro Spelkonsol",
      "Console de jeu rétro portable": "Bärbar Retro Spelkonsol",
      "Protection R36S": "R36S Skydd",
      "ADD TO CART": "LÄGG I VARUKORG",
      // EN remnants
      "Rated 4.8/5 — 2,400+ consoles shipped in 2026!": "Betyg 4.8/5 — 2 400+ konsoler skickade 2026!",
      // Catch-all
      "Le meilleur du retro-gaming au meilleur prix": "Det bästa inom retro-gaming till bästa pris",
      // Asian/Eastern fixes
      "Offre Basique": "Baserbjudande",
      "Meilleure Offre": "Bästa Erbjudandet",
      "Poignée": "Grepp",
      "rétro": "retro",
    },
    tr: {
      "Votre panier": "Sepetin", "Vous économisez": "Tasarruf",
      "COMMANDER": "SİPARİŞ VER",
      "LIVRAISON GRATUITE": "ÜCRETSİZ KARGO",
      "REMBOURSÉ 30 JOURS": "30 GÜN İADE",
      "PAIEMENT SÉCURISÉ": "GÜVENLİ ÖDEME",
      "Paiement express": "Hızlı ödeme",
      "🎁 Cadeau offert": "🎁 Hediye", "Cadeau offert": "Hediye",
      "Produit Gratuit": "Bedava Ürün", "Cadeaux": "Hediyeler", "Cadeau": "Hediye",
      "GRATUIT": "BEDAVA", "Gratuit": "Bedava",
      "Couleur:": "Renk:", "Couleur": "Renk",
      "Violet": "Mor", "Noir": "Siyah", "Blanc": "Beyaz",
      "PROFITEZ-EN VITE !": "ACELE ET!",
      "Stock limité": "Sınırlı stok",
      "AJOUTER AU PANIER": "SEPETE EKLE",
      "Accueil": "Anasayfa", "Contact": "İletişim",
      // Reviews
      "Noté 4.8 par 5000+ Clients!": "5000+ Müşteri tarafından 4.8 puanlı!",
      "Noté 4.8 par 5000+ Clients": "5000+ Müşteri tarafından 4.8 puanlı",
      "5000+ Clients": "5000+ Müşteri",
      "Clients!": "Müşteri!",
      "Noté": "Puanlandı",
      "Excellent": "Mükemmel",
      // Announcement bar
      "rapide et gratuite": "hızlı ve ücretsiz",
      "Livraison rapide et gratuite": "Hızlı ve ücretsiz kargo",
      // Product names + extras
      "R36S - Console de jeu rétro portable": "R36S - Taşınabilir Retro Oyun Konsolu",
      "Console de jeu rétro portable": "Taşınabilir Retro Oyun Konsolu",
      "Protection R36S": "R36S Kılıf",
      "ADD TO CART": "SEPETE EKLE",
      // EN remnants
      "Rated 4.8/5 — 2,400+ consoles shipped in 2026!": "4.8/5 puan — 2026'te 2.400+ konsol gönderildi!",
      // Catch-all
      "Le meilleur du retro-gaming au meilleur prix": "En iyi fiyatla en iyi retro oyun",
      // Asian/Eastern fixes
      "Offre Basique": "Temel Teklif",
      "Meilleure Offre": "En İyi Teklif",
      "Poignée": "Tutamak",
      "rétro": "retro",
    },
  };

  var dict = T[lang];
  if (!dict) return;

  // Sort keys longest-first
  var keys = Object.keys(dict).sort(function(a, b) { return b.length - a.length; });

  function escapeRegex(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  var RE = new RegExp(keys.map(escapeRegex).join('|'), 'g');

  // 02/10/2026 (audits/2026-10-02-retrait-sticky) : ne remplacer qu'un mot entier. Avant, « Violet » etait
  // remplace a l'interieur de « Violett » a chaque balayage (Violettttt en DE, Violetaaaa en ES, Totaleeee en IT...).
  var LAT = /[A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]/;
  function rep(m, off, str) {
    var tr = dict[m];
    if (!tr) return m;
    if (off > 0 && LAT.test(m.charAt(0)) && LAT.test(str.charAt(off - 1))) return m;
    var end = off + m.length;
    if (end < str.length && LAT.test(m.charAt(m.length - 1)) && LAT.test(str.charAt(end))) return m;
    return tr;
  }

  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, CODE: 1, PRE: 1, SELECT: 1, OPTION: 1 };

  function sweep() {
    try {
      // Also translate <title>
      if (document.title && !document.querySelector('.r36xp, [data-r36-localized]')) {
        var t = document.title;
        RE.lastIndex = 0;
        if (RE.test(t)) {
          RE.lastIndex = 0;
          var nt = t.replace(RE, rep);
          if (nt !== t) document.title = nt;
        }
      }
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
        acceptNode: function(n) {
          var p = n.parentNode;
          if (!p || SKIP[p.tagName]) return NodeFilter.FILTER_REJECT;
          // These sections are already translated server-side by Shopify.
          if (p.closest && p.closest('.r36xp, [data-r36-localized]')) return NodeFilter.FILTER_REJECT;
          var v = n.nodeValue;
          if (!v || v.length < 2) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var n, count = 0, max = 8000;
      while ((n = walker.nextNode()) && count < max) {
        count++;
        var v = n.nodeValue;
        RE.lastIndex = 0;
        if (!RE.test(v)) continue;
        RE.lastIndex = 0;
        var nv = v.replace(RE, rep);
        if (nv !== v) n.nodeValue = nv;
      }
    } catch(e) { /* silent */ }
  }

  function start() {
    sweep();
    [400, 1000, 2000, 3500, 5500, 8000, 12000, 18000, 25000].forEach(function(ms) {
      setTimeout(sweep, ms);
    });
  }

  // ========== LINK REWRITER (for blog articles + internal nav) ==========
  // Prefix internal links (href="/...") with the current language path
  // Skips: external, anchors, mailto, tel, already-prefixed
  function rewriteLinks() {
    try {
      // Extract current language prefix from window.location
      var m = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(\/|$)/i);
      if (!m) return; // No prefix = root FR, nothing to rewrite
      var prefix = '/' + m[1];

      var links = document.querySelectorAll('a[href^="/"]');
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        var href = a.getAttribute('href');
        if (!href || href.length < 1) continue;
        // Skip protocol-relative
        if (href.charAt(0) !== '/' || href.charAt(1) === '/') continue;
        // Skip already-prefixed with any locale (2-letter or 2-2 e.g. /en/, /pt-br/)
        if (/^\/[a-z]{2}(-[a-z]{2})?(\/|$|\?|#)/i.test(href)) continue;
        // Skip Shopify special routes that don't take locale prefix
        if (/^\/(cdn|admin|cart\.js|account\/|policies\/|apps\/)/i.test(href)) continue;
        // Apply prefix
        a.setAttribute('href', prefix + href);
      }
    } catch(e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { start(); rewriteLinks(); });
  } else {
    start();
    rewriteLinks();
  }
  // Run again after delay (for late-loaded content like blog cards, related posts)
  setTimeout(rewriteLinks, 1500);
  setTimeout(rewriteLinks, 4000);
})();
